import { ObjectBase } from '@awesome-nodes/object';
export class ObjectModel extends ObjectBase {}
